import React from "react";
import { useLocation } from "react-router-dom";
import { WHATSAPP_PHONE } from "../config";
import { trackEvent } from "../lib/analytics";

const WhatsAppFloat = () => {
  const location = useLocation();
  const url =
    typeof window !== "undefined"
      ? `${window.location.origin}${location.pathname}${location.search}${location.hash}`
      : "";
  const message = `Hola, quiero informacion sobre A1 Pro.\nURL: ${url}`;
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      className="whatsapp-float"
      href={whatsappUrl}
      onClick={() => trackEvent("whatsapp_click", { source: "floating_button" })}
      target="_blank"
      rel="noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      <i className="fa fa-whatsapp"></i>
    </a>
  );
};

export default WhatsAppFloat;
